// Bundled so PostHog never loads external scripts.
import "posthog-js/dist/exception-autocapture";
import {
  POSTHOG_HOST,
  POSTHOG_PROJECT_TOKEN,
  errorTrackingEnvironment,
  isErrorTrackingEnabled,
} from "@/lib/error-tracking/error-tracking-config";
import { attachErrorTrackingUser } from "@/lib/error-tracking/error-tracking-user";
import posthog, { type CaptureResult } from "posthog-js";

/** Drops `userError` rejections; PostHog keeps the class name as exception type. */
function dropIntentionalUserErrors(
  event: CaptureResult | null,
): CaptureResult | null {
  if (event === null || event.event !== "$exception") return event;
  const list: unknown = event.properties.$exception_list;
  if (!Array.isArray(list)) return event;
  const intentional = list.some(
    (entry: unknown) =>
      typeof entry === "object" &&
      entry !== null &&
      (entry as { type?: unknown }).type === "ConvexError",
  );
  return intentional ? null : event;
}

if (isErrorTrackingEnabled()) {
  // Errors only. Memory persistence: no cookies or storage, so no consent banner.
  posthog.init(POSTHOG_PROJECT_TOKEN, {
    api_host: POSTHOG_HOST,
    defaults: "2026-08-30",
    persistence: "memory",
    person_profiles: "identified_only",
    capture_exceptions: true,
    before_send: [dropIntentionalUserErrors, attachErrorTrackingUser],
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_dead_clicks: false,
    rageclick: false,
    capture_heatmaps: false,
    capture_performance: false,
    disable_session_recording: true,
    disable_surveys: true,
    disable_product_tours: true,
    disable_conversations: true,
    disable_web_experiments: true,
    disable_external_dependency_loading: true,
    advanced_disable_flags: true,
  });
  posthog.register({ environment: errorTrackingEnvironment() });
}
